export default "__VITE_ASSET__47aeb3fb__"